export default __webpack_public_path__ + "static/media/apvs-arte-1.231ff041.webp";